import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { longString } from "../../shared/src/codecs/types/longString";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { union } from "../../shared/src/codecs/types/union";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { CaseSellerReasonForSale1 } from "./CaseSellerReasonForSale";
import { CasesPurchasePaymentMethod1 } from "./CasesPurchasePaymentMethod";
import { TransactionType1 } from "./TransactionType";

export const EmailTemplate = required({
    id: uuid(),
    recipient: string(),
    acting_for: string(),
    use_case: string(),
    body: longString(),
    transaction_type: union([nullCodec(), TransactionType1]),
    seller_reason_for_sale: union([nullCodec(), CaseSellerReasonForSale1]),
    purchase_payment_method: union([nullCodec(), CasesPurchasePaymentMethod1]),
});
export type TEmailTemplateCodec = typeof EmailTemplate;
export type TEmailTemplate = TTypeOfCodec<TEmailTemplateCodec>;
